@if (uploadProgress$ | async; as uploadProgress) {
    <div class="flex row">
        <img class="flex-20" src="{{ uploadProgress.preview }}" />
        <p class="flex-80">{{ uploadProgress.uploadItem.name }}</p>
    </div>
    <p align="end">{{ uploadProgress.index }}/{{ uploadProgress.total }}</p>
    <mat-progress-bar
        mode="determinate"
        [value]="(uploadProgress.index / uploadProgress.total) * 100"
    ></mat-progress-bar>
}
